import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import Constants from '../../../definitions/constants';
import { intl } from '../../../locales/localesConfig';

/* Actions */
import * as biCalculationsSummaryActions from '../../actions/biCalculationsSummary/index';

import FullScreenGlassLoading from '../../components/common/interface/fullScreenGlassLoading';
import CalculationsSummaryTable from '../../components/biCalculationsSummary/calculationsSummaryTable';
import Header from '../../components/biCalculationsSummary/header';
import ErrorLoadingView from '../../components/common/interface/errorLoadingView';

class BiCalculationsSummary extends Component {
  constructor(props) {
    super(props);
  }
 
  async componentDidMount() {
    await this.props.actions.getCalculationsSummary();
  }
  
  componentWillUnmount() {
    this.props.actions.reset();
  }
  
  componentDidUpdate(prevProps) {

  }

  render() {
    var loadingView = this.props.calculationsSummary.firstLoading;
    var errorLoadingView = (this.props.calculationsSummary.status !== null && this.props.calculationsSummary.status !== 200);
    return (
      <section className="dashboard_content_inner_view entity_admin_container bi_calculations_summary_container">
        {
          loadingView ? (<FullScreenGlassLoading/>) : 
          errorLoadingView ? (<ErrorLoadingView/>) :
          (
            <section>
              <Header/>
              <CalculationsSummaryTable
                data={this.props.calculationsSummary.data}
                loading={this.props.calculationsSummary.loading}
              />
            </section>
          )
        }
      </section>
    );
  }
}

const mapStateToProps = state => ({
  calculationsSummary: state.reducer.biCalculationsSummary.calculationsSummary,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(biCalculationsSummaryActions, dispatch)
});

BiCalculationsSummary.propTypes = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BiCalculationsSummary);



// WEBPACK FOOTER //
// ./source/client/containers/biCalculationsSummary/index.jsx